import { Box, Flex, Text } from '@chakra-ui/react'
import { ChartSpline } from 'lucide-react'
import React from 'react'

import { useReportingI18n } from '../../../i18n'

const EmptyState: React.FC = () => {
  const { text } = useReportingI18n()

  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      padding="64px"
      height="100%"
      minHeight="400px"
      color="fg.muted"
      data-testid="queue-dashboard-empty-state"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        width="80px"
        height="80px"
        borderRadius="full"
        bg="bg.muted"
        mb="24px"
      >
        <Box
          as={ChartSpline}
          width="36px"
          height="36px"
          color="blue.focusRing"
        />
      </Flex>
      <Text fontSize="1.125rem" fontWeight="600" mb="8px" color="fg.default">
        {text('queueDashboard.emptyState.title', 'No information found')}
      </Text>
      <Text fontSize="0.875rem" color="fg.muted" textAlign="center">
        {text(
          'queueDashboard.emptyState.description',
          'Select a queue from the list to get view relevant data',
        )}
      </Text>
    </Flex>
  )
}

export default EmptyState
